<template>
  <a-row :gutter="24">
    <a-col :span="24">
      <a-form-model-item label="房源名称" prop="housingResName">
        <a-input
          v-model="form.housingResName"
          placeholder="请输入房源名称"
          :disabled="!isEditable"
        />
      </a-form-model-item>
    </a-col>

    <!-- 字典 -->
    <a-col :span="24">
      <a-form-model-item label="房源所在省/市/区(县)" prop="housingResCode">
        <a-cascader
          v-model="form.housingResCode"
          :options="options.addressCode"
          :load-data="loadData"
          placeholder="请选择房源所在省/市/区(县)"
          notFoundContent="正在加载..."
          change-on-select
          @popupVisibleChange="areaDictionaries"
          @change="onHousingResAddressChange"
          :disabled="!isEditable"
        >
          <template slot="displayRender" slot-scope="{ labels }">
            {{
              (!selectProvinceType || !(options?.addressCode?.length > 0)) &&
              form?.housingResCode?.length > 0
                ? housingAddressString
                : labels.join(" / ")
            }}
          </template>
        </a-cascader>
      </a-form-model-item>
    </a-col>

    <a-col :span="24">
      <a-form-model-item label="详细地址" prop="housingResAddress">
        <a-input
          v-model="form.housingResAddress"
          placeholder="请输入详细地址"
          :disabled="!isEditable"
        />
      </a-form-model-item>
    </a-col>
  </a-row>
</template>

<script>
const LEAF_REGIONS = ["台湾省", "香港特别行政区", "澳门特别行政区"];
import { getProvinceList, getAreaList } from "@/api/shexgrp/Dictionaries.js";
import { initProvinceList } from "@/api/shexgrp/InitDictionaries.js";
export default {
  props: {
    form: {
      type: Object,
      default: () => null,
    },
    housingAddressString: {
      type: String,
      default: undefined,
    },
    isEditable: {
      type: Boolean,
      default: () => true,
    },
  },

  data() {
    return {
      options: {
        addressCode: [],
      },
      //是否选中一级地址标志位，用于判断是否显示固定地址
      selectProvinceType: false,
    };
  },

  mounted() {
    this.initAreaDictionaries();
  },

  methods: {
    // 用户“选中一级地址”时触发
    onHousingResAddressChange() {
      this.selectProvinceType = true;
    },

    // 通用加载省份列表
    async loadAreaDictionaries(apiFn, errorMsg, visible = true) {
      if (!visible) return;

      // 已有省份数据，直接返回
      if (this.options.addressCode.length > 0) return;

      try {
        const res = await apiFn();

        if (res && res.code === "200") {
          setTimeout(() => {
            const list = (res.data || []).map((item) => ({
              label: item.XZQYMC,
              value: item.XZQYDM,
              isLeaf: LEAF_REGIONS.includes(item.XZQYMC),
            }));

            this.options.addressCode = this.sortAreaList(list);
          }, 300);
        }
      } catch (e) {
        console.error(errorMsg, e);
      }
    },

    // 初始化省份列表
    initAreaDictionaries() {
      return this.loadAreaDictionaries(initProvinceList, "省份列表初始化失败");
    },

    // 获取省份列表
    areaDictionaries(visible) {
      return this.loadAreaDictionaries(
        getProvinceList,
        "省份列表加载失败",
        visible
      );
    },

    //便利性优化排序地点
    sortAreaList(list) {
      const CURRENCY_PRIORITY = {
        北京: 1,
        上海: 2,
      };

      return list.slice().sort((a, b) => {
        const pa = CURRENCY_PRIORITY[a.label] || 999;
        const pb = CURRENCY_PRIORITY[b.label] || 999;
        return pa - pb;
      });
    },

    //更新新地区列表信息
    async loadData(selectedOptions) {
      const targetOption = selectedOptions[selectedOptions.length - 1];

      // 开启当前节点 loading（自动显示 Spin）
      targetOption.loading = true;

      try {
        const res = await getAreaList({
          sjxzqydm: targetOption.value,
        });

        if (res?.code === "200") {
          targetOption.children = (res.data || []).map((item) => ({
            label: item.XZQYMC,
            value: item.XZQYDM,
            isLeaf: selectedOptions.length >= 2, // 后端返回是否还有下级
          }));
          this.options.addressCode = [...this.options.addressCode];
        }
      } catch (e) {
        console.error("级联地址加载失败", e);
      } finally {
        // 关闭 loading
        targetOption.loading = false;
      }
    },
  },
};
</script>

<style>
</style>